import { render, staticRenderFns } from "./CadastrarRepresentante.vue?vue&type=template&id=46095120"
import script from "./CadastrarRepresentante.vue?vue&type=script&lang=js"
export * from "./CadastrarRepresentante.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports